import { ModelFactory } from "@shared/factories/model.factory";
import { ItemsToVerifyType} from "@generated/graphql";
import { ItemsToVerify } from "../models/items-to-verify.model";

export class ItemsToVerifyFactory extends ModelFactory<ItemsToVerifyType, ItemsToVerify> {
  create (state: ItemsToVerifyType): ItemsToVerify {
   return new ItemsToVerify(state)
  }

  fake (): ItemsToVerify {
    throw new Error('This method is not implemented')
  }
}

export const itemsToVerifyFactory = new ItemsToVerifyFactory()
